import { formatPercent } from "@angular/common";
import {
  Inject,
  LOCALE_ID,
  Pipe,
  PipeTransform,
  Optional,
} from "@angular/core";
import { ConfigurationManager } from "../services/configuration-manager.service";
import { DigitsInfoHelper } from "../helpers/digits-info-helper";

@Pipe({
    name: "wafPercent",
    standalone: false
})
export class PercentStringPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private configurationManager: ConfigurationManager
  ) {}

  transform(value: number, digitInfo?: string): string {
    if (value != undefined) {
      if (!digitInfo) {
        digitInfo = DigitsInfoHelper.convertToString(
          this.configurationManager.getPercentDigitInfo()
        );
      }

      return formatPercent(value, this.locale, digitInfo);
    }

    return "";
  }
}
